module.exports = __webpack_public_path__ + "img/scene7.c537c153.gif";